// global-intel.ts
// CONTRACT:P1-CANONICAL-ENVELOPE.1.0
//
// COP — the WIRED multi-INT "Global Intel" theater (Arc 2). A thin wrapper that binds
// ./scenario-global-intel.json to the generic theater loader (./theaters.ts), mirroring
// hormuz.ts's public surface (startGlobalIntelScenario / globalIntelEnvelopes). The
// dataset folds the TDFBot haystack tracks (~1,019) + curated multi-INT records (42)
// into ONE richer picture; every record carries REAL corpus markings (copied verbatim
// by scripts/gen-global-intel-scenario.mjs) and is published as a CanonicalEnvelope onto
// the SAME bus → LOCAL PDP (I4) → render path, so the clearance filter bites on the
// WHOLE picture (permit → show / deny → absent).
//
// Static JSON import (Phase A) — the corpus rides in the bundle like taiwan/levant. If
// bundle-size is ever flagged, a dynamic import is a documented follow-up.

import type { EnvelopeBus } from "../host/envelopeBus.ts";
import type { CanonicalEnvelope } from "../../../../packages/schema/ts/envelope.ts";
import {
  startTheaterScenario,
  theaterEnvelopes,
  type TheaterDef,
  type TheaterHandle,
  type TheaterRecord,
} from "./theaters.ts";
import globalIntelData from "./scenario-global-intel.json";

/** The Global Intel theater definition (the corpus + its stamped metadata). */
export const GLOBAL_INTEL_THEATER: TheaterDef = {
  id: "global-intel",
  label: "Global Intel",
  records: globalIntelData as unknown as TheaterRecord[],
};

export interface GlobalIntelHandle extends TheaterHandle {}

/** Project the Global Intel corpus to envelopes once (static snapshot / tests). */
export function globalIntelEnvelopes(): CanonicalEnvelope[] {
  return theaterEnvelopes(GLOBAL_INTEL_THEATER);
}

/** Start the live Global Intel picture (emit-once + per-tick re-emit). */
export function startGlobalIntelScenario(bus: EnvelopeBus, tickMs = 1_000): GlobalIntelHandle {
  return startTheaterScenario(GLOBAL_INTEL_THEATER, bus, tickMs);
}
